import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({ uri: process.env.REACT_APP_API_URL });

const authLink = setContext((_, { headers }) => {
  const sessionId = localStorage.getItem("sessionId");
  return {
    headers: { ...headers, authorization: sessionId }
  };
});

const apolloClient = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      notifyOnNetworkStatusChange: true
    }
  }
});

export default apolloClient;
